

<template>
    <div> 
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>  
    </div>
</template>


<script>
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'

import liff from '@line/liff';

export default {
    name: 'HiQuiz',
    components:{},
    data () {
        return {
            UserData:{},
            profile: null,
            AccessToken:'',
            ProviderUserId:'',
            showLoading:'',
        }
    },
    
    beforeCreate(){
        liff.init({ liffId: process.env.LIFFHIQUIZ })
        .then(async () => {
            if (liff.isLoggedIn()) {
                this.profile = liff.getProfile();
                this.AccessToken = liff.getAccessToken();
                console.log('profile',this.profile)
                console.log('AccessToken',this.AccessToken)
                sessionStorage.setItem('AccessToken',this.AccessToken);
                this.profile.then((value) => {
                    sessionStorage.setItem('profile', JSON.stringify(value));
                    this.ProviderUserId = value.userId;
                    this.$nextTick(() => {
                        // console.log('ProviderUserId',this.ProviderUserId);
                        this.CheckThirdPartyAuthUserId();
                    });
                });
                
            } else {
                liff.login();
            }
        })
        .catch((err) => {
            console.log(err);
        })
    },
    mounted(){
        // this.AccessToken = 'eyJhbGciOiJIUzI1NiJ9.Q0Cm0XZc-yxFweK9xGQExe-KTLNkUdnwJa8rRC4XzRmf70hAIgQPG-PEZXqimlMyJZ9mQ4dgXBHoGErSYhhGcbiXc3Y_wuW-jwRyp1jb-CfUq5cGowyFxTNcM6evkfMfCWEnTEWdOhnQjYVNLuwWwdqyMjWFn4xKstYndP4Q1I8.IpePUiyXFbLOY3s69b7g7oIb621b0hYaal-l7foiJvA';
        // this.ProviderUserId = 'Udc9c2afbb5f863f8ee6bb3708aab1789';
        // sessionStorage.setItem('profile', JSON.stringify({"userId":"Udc9c2afbb5f863f8ee6bb3708aab1789","displayName":"Hi-IT"}));
        // sessionStorage.setItem('AccessToken', this.AccessToken);
        // this.CheckThirdPartyAuthUserId();
    },
    methods:{
        //驗證是否綁定過Line ID
        CheckThirdPartyAuthUserId(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Login/CheckThirdPartyAuthUserId`;
            const inputdata = 
            {
                "ProviderId":1, // Line用,
                "AccessToken":this.AccessToken,
                "ProviderUserId": this.ProviderUserId,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){
                        this.UserData = response.data.userData;
                        var url = '';
                        if(`${process.env.NODE_ENV}` == "production"){//master
                            url = 'http://hiquiz.hi-tr.com/?token=' + this.UserData.token + '&userId=' + this.UserData.userId;
                        }else{ //demo
                            url = 'http://hiquizdemo.hitutor.com.tw/?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ0ZXN0MTYxMDI2ZGRAa2sudHQiLCJuYW1laWQiOiI3MTIzMCIsInR5cCI6IlMiLCJlbWFpbCI6InRlc3QxNjEwMjZkZEBray50dCIsIm5iZiI6MTY4MDA3NDM3MywiZXhwIjoxNzExNjk2NzczLCJpYXQiOjE2ODAwNzQzNzMsImlzcyI6IkhpVHV0b3IifQ.JEeMw3uvwHNC0P5yKsxb_H4PB_CZkgaakWhtyFOPpVo&userId=71230'
                            // url = 'http://hiquizdemo.hitutor.com.tw/?token=' + this.UserData.token + '&userId=' + this.UserData.userId;
                        }
                        this.GoHiQuiz(url);
                    }else{
                        //跳轉登入畫面
                        this.$router.push({
                            name: 'Login',
                        });
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        GoHiQuiz(URL){
            liff.openWindow({
                url: URL,
                external: true,
            });
        },
    },
    created(){
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/HiQuiz.vue